// extracted by mini-css-extract-plugin
export default {"container":"WSDateRangeSelect-module_container-A6ItG","dateInput":"WSDateRangeSelect-module_dateInput-LM3n2"};